import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import OperatorProjectWorkspaceApi from "../../../../../infrastructure/api/operatorProjectWorkspaceApi";
import { normalizePartnerReferralFilterApiResponse } from "../../../../../infrastructure/utils/partnerReferralFilterApi";
import {
  buildPartnerReferralFilterOptionsFromRows,
  mergePartnerReferralFilterOptions,
} from "./partnerReferralFilterUtils";

const PartnerReferralFilterSelect = ({
  value,
  onChange,
  rows = [],
  size = "small",
  fullWidth = true,
  label = "معرف (سطح یک)",
  fetchPartnerReferralFilterOptions = OperatorProjectWorkspaceApi.getPartnerReferralFilterOptions,
}) => {
  const [apiOptions, setApiOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const loadOptions = async () => {
      try {
        const res = await fetchPartnerReferralFilterOptions();
        const normalized = normalizePartnerReferralFilterApiResponse(res);
        if (!cancelled && normalized.isSuccess) {
          setApiOptions(normalized.data || []);
        }
      } catch {
        if (!cancelled) setApiOptions([]);
      }
    };

    loadOptions();
    return () => {
      cancelled = true;
    };
  }, [fetchPartnerReferralFilterOptions]);

  const options = useMemo(
    () =>
      mergePartnerReferralFilterOptions(
        apiOptions,
        buildPartnerReferralFilterOptionsFromRows(rows)
      ),
    [apiOptions, rows]
  );

  return (
    <FormControl fullWidth={fullWidth} size={size}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        label={label}
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value="">همه معرف‌ها</MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PartnerReferralFilterSelect;
